// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Offer Card ─────────────────────────────────────────── */
.ofc-card {
  border-radius: 24px;
  padding: 16px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.04);
  transition: all 0.2s ease-in-out;
}

/* Alternate Card Variant Styling based on index classes */
.ofc-card.ofc-card-odd {
  border: 1px solid #dbeafe; /* border-blue-100 */
  background: linear-gradient(180deg, rgba(248, 251, 255, 0.96) 0%, #ffffff 100%);
}

.ofc-card.ofc-card-even {
  border: 1px solid #e2e8f0; /* border-slate-200 */
  background: linear-gradient(180deg, #fbfcfe 0%, #f8fafc 100%);
}

/* Shared label style (Offer type / Main product / etc.) */
.ofc-label {
  display: block;
  font-size: 10px !important;
  font-weight: 500;
  color: #94a3b8; /* text-slate-400 */
  letter-spacing: 0.18em;
  text-transform: uppercase;
  margin-bottom: 4px;
}

/* Header row */
.ofc-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.ofc-header-left {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.ofc-title {
  font-size: 15px !important;
  font-weight: 600;
  color: #334155; /* text-slate-800 */
  line-height: 1.4;
  margin-top: 4px;
}

/* Product columns */
.ofc-products {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 12px; /* mt-3 */
}

@media (max-width: 480px) {
  .ofc-products {
    grid-template-columns: 1fr;
  }
}

.ofc-product-col {
  min-width: 0;
  border-radius: 18px;
  background-color: rgba(255, 255, 255, 0.75);
  padding: 12px 14px; /* px-3.5 py-3 */
  border: 1px solid #f1f5f9; /* ring-1 ring-slate-100 */
  box-shadow: 0 0 0 1px #f1f5f9;
  display: flex;
  flex-direction: column;
}

.ofc-product-name {
  font-size: 14px !important; /* text-sm */
  font-weight: 500; /* font-medium */
  color: #334155; /* text-slate-800 */
  line-height: 1.25rem; /* leading-5 */
  margin-top: 6px; /* mt-1.5 */
}

.ofc-product-mrp {
  font-size: 14px !important; /* text-sm */
  color: #64748b; /* text-slate-500 */
  margin-top: 4px; /* mt-1 */
}

/* Offer rule */
.ofc-rule {
  border-radius: 18px;
  padding: 12px 14px; /* px-3.5 py-3 */
  background-color: rgba(248, 250, 252, 0.85); /* bg-slate-50/85 */
  border: 1px solid #f1f5f9; /* ring-1 ring-slate-100 */
  box-shadow: 0 0 0 1px #f1f5f9;
  margin-top: 12px; /* mt-3 */
}

.ofc-rule-text {
  font-size: 14px !important; /* text-sm */
  color: #475569; /* text-slate-600 */
  line-height: 1.25rem; /* leading-5 */
  margin-top: 6px; /* mt-1.5 */
}

.ofc-apply-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 20px;
  border: 0;
  border-radius: 999px;
  background: #2563eb;
  color: #ffffff;
  font-size: 13px !important;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.15s;
}

.ofc-apply-btn:hover {
  background: #1d4ed8;
}

.ofc-apply-btn:disabled {
  background: #e5e7eb;
  color: #9ca3af;
  cursor: not-allowed;
}

/* Dark mode overrides */
.dark .ofc-card.ofc-card-odd {
  background: linear-gradient(180deg, rgba(30, 41, 59, 0.96) 0%, #0f172a 100%);
  border-color: #1e3a8a;
}

.dark .ofc-card.ofc-card-even {
  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
  border-color: #334155;
}

.dark .ofc-title {
  color: #f1f5f9;
}

.dark .ofc-product-col {
  background-color: rgba(15, 23, 42, 0.75);
  border-color: #334155;
  box-shadow: 0 0 0 1px #334155;
}

.dark .ofc-product-name {
  color: #e2e8f0;
}

.dark .ofc-rule {
  background-color: rgba(30, 41, 59, 0.85);
  border-color: #334155;
  box-shadow: 0 0 0 1px #334155;
}

.dark .ofc-rule-text {
  color: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/offers/components/offersCard/offersCard.css"],"names":[],"mappings":"AAAA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,kCAAkC;EAClC,8CAA8C;EAC9C,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,+EAA+E;AACjF;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,6DAA6D;AAC/D;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc,EAAE,mBAAmB;EACnC,gBAAgB;EAChB,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB,EAAE,SAAS;AAC7B;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB,EAAE,gBAAgB;EACpC,yBAAyB,EAAE,0BAA0B;EACrD,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B,EAAE,YAAY;EACxC,gBAAgB,EAAE,gBAAgB;EAClC,cAAc,EAAE,mBAAmB;EACnC,oBAAoB,EAAE,cAAc;EACpC,eAAe,EAAE,WAAW;AAC9B;;AAEA;EACE,0BAA0B,EAAE,YAAY;EACxC,cAAc,EAAE,mBAAmB;EACnC,eAAe,EAAE,SAAS;AAC5B;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,kBAAkB,EAAE,gBAAgB;EACpC,2CAA2C,EAAE,mBAAmB;EAChE,yBAAyB,EAAE,0BAA0B;EACrD,6BAA6B;EAC7B,gBAAgB,EAAE,SAAS;AAC7B;;AAEA;EACE,0BAA0B,EAAE,YAAY;EACxC,cAAc,EAAE,mBAAmB;EACnC,oBAAoB,EAAE,cAAc;EACpC,eAAe,EAAE,WAAW;AAC9B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,4EAA4E;EAC5E,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* ── Offer Card ─────────────────────────────────────────── */\n.ofc-card {\n  border-radius: 24px;\n  padding: 16px;\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.04);\n  transition: all 0.2s ease-in-out;\n}\n\n/* Alternate Card Variant Styling based on index classes */\n.ofc-card.ofc-card-odd {\n  border: 1px solid #dbeafe; /* border-blue-100 */\n  background: linear-gradient(180deg, rgba(248, 251, 255, 0.96) 0%, #ffffff 100%);\n}\n\n.ofc-card.ofc-card-even {\n  border: 1px solid #e2e8f0; /* border-slate-200 */\n  background: linear-gradient(180deg, #fbfcfe 0%, #f8fafc 100%);\n}\n\n/* Shared label style (Offer type / Main product / etc.) */\n.ofc-label {\n  display: block;\n  font-size: 10px !important;\n  font-weight: 500;\n  color: #94a3b8; /* text-slate-400 */\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n/* Header row */\n.ofc-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ofc-header-left {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.ofc-title {\n  font-size: 15px !important;\n  font-weight: 600;\n  color: #334155; /* text-slate-800 */\n  line-height: 1.4;\n  margin-top: 4px;\n}\n\n/* Product columns */\n.ofc-products {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-top: 12px; /* mt-3 */\n}\n\n@media (max-width: 480px) {\n  .ofc-products {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ofc-product-col {\n  min-width: 0;\n  border-radius: 18px;\n  background-color: rgba(255, 255, 255, 0.75);\n  padding: 12px 14px; /* px-3.5 py-3 */\n  border: 1px solid #f1f5f9; /* ring-1 ring-slate-100 */\n  box-shadow: 0 0 0 1px #f1f5f9;\n  display: flex;\n  flex-direction: column;\n}\n\n.ofc-product-name {\n  font-size: 14px !important; /* text-sm */\n  font-weight: 500; /* font-medium */\n  color: #334155; /* text-slate-800 */\n  line-height: 1.25rem; /* leading-5 */\n  margin-top: 6px; /* mt-1.5 */\n}\n\n.ofc-product-mrp {\n  font-size: 14px !important; /* text-sm */\n  color: #64748b; /* text-slate-500 */\n  margin-top: 4px; /* mt-1 */\n}\n\n/* Offer rule */\n.ofc-rule {\n  border-radius: 18px;\n  padding: 12px 14px; /* px-3.5 py-3 */\n  background-color: rgba(248, 250, 252, 0.85); /* bg-slate-50/85 */\n  border: 1px solid #f1f5f9; /* ring-1 ring-slate-100 */\n  box-shadow: 0 0 0 1px #f1f5f9;\n  margin-top: 12px; /* mt-3 */\n}\n\n.ofc-rule-text {\n  font-size: 14px !important; /* text-sm */\n  color: #475569; /* text-slate-600 */\n  line-height: 1.25rem; /* leading-5 */\n  margin-top: 6px; /* mt-1.5 */\n}\n\n.ofc-apply-btn {\n  flex-shrink: 0;\n  height: 34px;\n  padding: 0 20px;\n  border: 0;\n  border-radius: 999px;\n  background: #2563eb;\n  color: #ffffff;\n  font-size: 13px !important;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.15s;\n}\n\n.ofc-apply-btn:hover {\n  background: #1d4ed8;\n}\n\n.ofc-apply-btn:disabled {\n  background: #e5e7eb;\n  color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Dark mode overrides */\n.dark .ofc-card.ofc-card-odd {\n  background: linear-gradient(180deg, rgba(30, 41, 59, 0.96) 0%, #0f172a 100%);\n  border-color: #1e3a8a;\n}\n\n.dark .ofc-card.ofc-card-even {\n  background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);\n  border-color: #334155;\n}\n\n.dark .ofc-title {\n  color: #f1f5f9;\n}\n\n.dark .ofc-product-col {\n  background-color: rgba(15, 23, 42, 0.75);\n  border-color: #334155;\n  box-shadow: 0 0 0 1px #334155;\n}\n\n.dark .ofc-product-name {\n  color: #e2e8f0;\n}\n\n.dark .ofc-rule {\n  background-color: rgba(30, 41, 59, 0.85);\n  border-color: #334155;\n  box-shadow: 0 0 0 1px #334155;\n}\n\n.dark .ofc-rule-text {\n  color: #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
